import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";

import user_service from "../service/user_service";
import Loader from "../../Pages/Loader/Loader.js";
import Toaster from "../../Pages/Toaster/Toaster";

export default function NewsletterArchiveDetail() {
  const { id } = useParams();
  const [loader, setLoader] = useState({ isActive: null });
  const { isActive } = loader;

  const [toaster, setToaster] = useState({
    types: null,
    isShow: null,
    toasterBody: "",
    message: "",
  });
  const { types, isShow, toasterBody, message } = toaster;

  const [item, setItem] = useState(null);

  const load = async () => {
    setLoader({ isActive: true });
    try {
      const res = await user_service.newslettersArchiveGetById(id);
      setItem(res?.data || null);
    } catch (e) {
      setToaster({
        types: "error",
        isShow: true,
        toasterBody: e?.response?.data?.message || "Failed to load newsletter.",
        message: "Error",
      });
    } finally {
      setLoader({ isActive: false });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="bg-secondary float-left w-100 pt-4">
      <Loader isActive={isActive} />
      {isShow && (
        <Toaster types={types} isShow={isShow} toasterBody={toasterBody} message={message} />
      )}
      <main className="page-wrapper">
        <div className="container pb-5">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-white mb-0">{item?.title || "Newsletter"}</h3>
            <NavLink className="btn btn-secondary" to="/newsletter-archive">
              Back to archive
            </NavLink>
          </div>

          <div className="bg-light border rounded-3 p-3">
            <div className="text-muted small mb-3">
              {item?.publishDate ? `Published: ${new Date(item.publishDate).toLocaleDateString()}` : ""}
              {item?.sentAt ? ` · Sent: ${new Date(item.sentAt).toLocaleString()}` : ""}
            </div>

            <div dangerouslySetInnerHTML={{ __html: item?.body || "" }} />
          </div>
        </div>
      </main>
    </div>
  );
}

